<template>
  <div>
    <a-drawer
      width="700"
      placement="right"
      :closable="false"
      :z-index="99"
      @close="close"
      :visible="show"
      :bodyStyle="{
        padding: 0,
      }"
    >
      <div
        slot="title"
        style="display: flex;flex-direction: row;align-items: center;"
      >
        <a-icon
          @click="close"
          style="color: #999;margin-right: 8px;cursor: pointer;font-size: 14px;"
          type="close"
        />
        <div class="title">
          AI助手小米粒
        </div>
      </div>
      <div class="body">
        <img class="ai-banner" src="../../assets/ai//banner.jpg" alt="" />

        <section class="ai-form">
          <div class="item">
            <div class="title">
              观察评测
            </div>
            <div class="ai-list">
              <div class="cell">
                <img class="icon" src="../../assets/ai/ai-search.jpg" alt="" />
                <div class="msg">
                  <div class="name">观察分析</div>
                  <div class="tip">
                    通过老师的观察白描，提供观察分析、策略、建议及发展目标
                  </div>
                </div>
                <div @click="handleUse('chatMessages')" class="btn">使用</div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="title">
              创作能手
            </div>
            <div class="ai-list">
              <!-- <div class="cell">
                <img class="icon" src="../../assets/ai/ai-editor.jpg" alt="" />
                <div class="msg">
                  <div class="name">撰写主题文案</div>
                  <div class="tip">
                    根据不同情况生成主题文案的撰写
                  </div>
                </div>
                <div @click="handleUse('articleEditor')" class="btn">使用</div>
              </div> -->
              <div class="cell">
                <img class="icon" src="../../assets/ai/ai-write.png" alt="" />
                <div class="msg">
                  <div class="name">文案扩写/优化</div>
                  <div class="tip">
                    根据老师提供的文案，提供扩写与润色
                  </div>
                </div>
                <div @click="handleUse('articleEditor')" class="btn">使用</div>
              </div>
              <div class="cell">
                <img class="icon" src="../../assets/ai/ai-error.jpg" alt="" />
                <div class="msg">
                  <div class="name">文案错别字检查</div>
                  <div class="tip">
                    检查文案中的错别字
                  </div>
                </div>
                <div @click="handleUse('errCheck')" class="btn">使用</div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </a-drawer>
    <a-drawer
      width="700"
      placement="right"
      :closable="false"
      :z-index="199"
      @close="showDetail = false"
      :visible="showDetail"
      :bodyStyle="{
        padding: '0 0 90px 0',
      }"
    >
      <div
        slot="title"
        v-if="showDetail"
        style="display: flex;flex-direction: row;align-items: center;"
      >
        <a-icon
          @click="showDetail = false"
          style="color: #999;margin-right: 8px;cursor: pointer;font-size: 14px;"
          type="close"
        />
        <div class="title">
          AI助手小米粒
        </div>
      </div>
      <div class="body">
        <div class="bg">
          <img class="icon" src="../../assets/ai/ml.png" alt="" />
          <div class="right">
            <div class="name">{{ chatData[type].title }}</div>
            <div class="time">
              <a-icon style="margin-right: 4px;" type="clock-circle"></a-icon
              >今日可用次数：{{ chatData[type].remain_query_count }}
            </div>
          </div>
        </div>
        <section class="ai-form" style="margin-top: -85px;">
          <div class="form-wrapper">
            <div v-if="chatData[type].params.length" class="tip2">
              请填写你的需求，填写越详细，生成效果越好哦~
            </div>
            <div
              v-for="(item, index) in chatData[type].params"
              :key="index"
              class="form-item"
            >
              <div class="title">{{ item.name }}</div>
              <component
                style="width: 100%;"
                :style="item.component == 'a-textarea' ? 'height: 100px;' : ''"
                :is="item.component"
                v-model="form[item.value]"
                :placeholder="item.description"
                :options="item.options"
              ></component>
            </div>
            <div v-if="chatData[type].query" class="form-item">
              <!-- <div class="title">提问</div> -->
              <a-textarea
                style="border: none;"
                v-model="query"
                border="none"
                :placeholder="chatData[type].queryDes"
                :auto-size="{ minRows: 4 }"
              />
            </div>
          </div>
        </section>
        <div class="foot">
          <div @click="handleConfirm" class="btn">立即生成</div>
        </div>
      </div>
    </a-drawer>

    <a-drawer
      width="700"
      placement="right"
      :closable="false"
      :z-index="999"
      @close="showAiDetail = false"
      :visible="showAiDetail"
      :bodyStyle="{
        padding: '0 0 90px 0',
      }"
    >
      <div
        slot="title"
        v-if="showAiDetail"
        style="display: flex;flex-direction: row;align-items: center;"
      >
        <a-icon
          @click="showAiDetail = false"
          style="color: #999;margin-right: 8px;cursor: pointer;font-size: 14px;"
          type="close"
        />
        <div class="title">
          AI助手小米粒
        </div>
      </div>
      <div class="body">
        <div class="bg">
          <img class="icon" src="../../assets/ai/ml.png" alt="" />
          <div class="right">
            <div class="name">{{ chatData[type].title }}</div>
            <div class="time">
              <a-icon style="margin-right: 4px;" type="clock-circle"></a-icon
              >今日可用次数：{{ chatData[type].remain_query_count }}
            </div>
          </div>
        </div>
        <section class="ai-form" style="margin-top: -85px;">
          <div class="content">
            <div :key="this.content" class="markdown">
              <vue-markdown :source="content"></vue-markdown>
            </div>
            <a-spin style="height: 30px;width: 100%;" v-if="loading">
              正在生成中...
            </a-spin>
          </div>
        </section>
        <div v-if="content" class="foot2">
          <a-space>
            <a-button
              @click="showAiDetail = false"
              type="link"
              style="color: #888;"
              ><a-icon type="edit"></a-icon>返回修改</a-button
            >
          </a-space>
          <div @click="handleCopy" class="btn">一键复制</div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import { directorTestApi } from "../../api/api-director";
import VueMarkdown from "vue-markdown";

export default {
  data() {
    return {
      show: false,
      showDetail: false,
      showAiDetail: false,
      query: "帮我生成文案",
      form: {},
      type: "chatMessages",
      content: "",
      loading: false,
      chatData: {
        chatMessages: {
          title: "观察分析",
          url: "https://dify.dzuo.net/v1/chat-messages",
          method: "POST",
          query_limit_day:50, // 每天查询次数限制
          id:'',
          url2:"/eval/ai/chat1.htm",
          aiKey: "app-TlsajIZZ9Krzzio7qGuRofI6",
          query: false,
          params: [
          {
              name: "年级",
              value: "age",
              type: "select",
              required: true,
              component: "a-select",
              description: "请选择幼儿年级",
              options: [
                {
                  label: "小班",
                  value: "小班",
                  key: "小班",
                },
                {
                  label: "中班",
                  value: "中班",
                  key: "中班",
                },
                {
                  label: "大班",
                  value: "大班",
                  key: "大班",
                },
              ],
            },
            {
              name: "学生姓名",
              value: "name",
              type: "string",
              required: true,
              component: "a-input",
              description: "请输入幼儿姓名",
            },
            {
              name: "观察场景",
              value: "scene",
              type: "string",
              required: true,
              component: "a-input",
              description: "描述在哪里",
            },
            {
              name: "观察白描",
              value: "find",
              type: "string",
              required: true,
              component: "a-textarea",
              description:
                "",
            },
            // 描述观察到的要点。如小明画画很认真，线条流畅，喜欢涂颜色，但涂得不仔细

            // {
            //   name: "内容类型",
            //   value: "project",
            //   type: "select",
            //   required: true,
            //   component: "a-select",
            //   description: "请选择生成内容类型",
            //   options: [
            //     {
            //       label: "观察分析",
            //       key: "观察分析",
            //       value: "观察分析",
            //     },
            //     {
            //       label: "回应策略",
            //       key: "回应策略",
            //       value: "回应策略",
            //     },
            //     {
            //       label: "家庭指导",
            //       key: "家庭指导",
            //       value: "家庭指导",
            //     },
            //   ],
            // },
          ],
        },
        articleEditor: {
          id:'',
          title: "文案优化和扩写",
          url: "https://dify.dzuo.net/v1/chat-messages",
          url2:"/eval/ai/chat1.htm",
          method: "POST",
          query_limit_day:50, // 每天查询次数限制
          aiKey: "app-FlB8rMbDDyVdKG7pbqFQ9Dlu",
          query: true,
          queryDes: "请输入需要扩写与优化的内容",
          params: [],
        },
        errCheck: {
          id:'',
          query_limit_day:50, // 每天查询次数限制
          title: "文案错别字检查",
          url2:"/eval/ai/chat1.htm",
          url: "https://dify.dzuo.net/v1/chat-messages",
          method: "POST",
          aiKey: "app-kBzSzG1HUsvfBoO0VP655laz",
          query: true,
          queryDes: "请输入需要检查错别字的内容",
          params: [],
        },
      },
      lastStr:'',
      waitText:'',
      waitIndex: 0,
      markContent:''
    };
  },
  computed: {
    ...mapState(["userInfo",'headers']),
  },
  components: {
    VueMarkdown,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(val) {
      console.log(val);
      this.show = val;
      if (val) {
        this.getKeys()
      }
    },
    showAiDetail(val) {
      if (!val) {
        this.content = "";
        this.waitText = '';
        this.waitIndex = 0;
        this.lastStr = '';
        this.markContent = ''
        clearInterval(this.timer);
      } 
    }
  },
  created() {
    this.getKeys()
  },
  methods: {
    getKeys() {
      axios({
        url: directorTestApi.main + directorTestApi.getAikeyList,
        headers: { "content-type": "application/x-www-form-urlencoded", Authorization: this.headers },
        method: 'POST',
        // data: qs.stringify()
      }).then((res) => {
        console.log(res);
        if (res.data.result) {
          for (let i = 0; i < res.data.data.length; i++) {
            const element = res.data.data[i];
            if (element.name.indexOf('观察分析') > -1) {
              // this.chatData.chatMessages.url = element.host
              this.chatData.chatMessages.query_limit_day = element.query_limit_day || 50
              this.chatData.chatMessages.remain_query_count = element.remain_query_count || 50
              this.chatData.chatMessages.id = element.id
            } else if (element.name.indexOf('文案优化') > -1) {
              // this.chatData.articleEditor.url = element.host
              this.chatData.articleEditor.query_limit_day = element.query_limit_day || 50
              this.chatData.articleEditor.remain_query_count = element.remain_query_count || 50
              this.chatData.articleEditor.id = element.id
            } else if (element.name.indexOf('错别字') > -1) {
              // this.chatData.errCheck.url = element.host
              this.chatData.errCheck.query_limit_day = element.query_limit_day || 50
              this.chatData.errCheck.remain_query_count = element.remain_query_count || 50
              this.chatData.errCheck.id = element.id
            }
          }

          //强制更新
          this.$forceUpdate()
        } else {
          this.$message.error(res.data.message);
        }
        
      })
    },
    convertMarkdownToHTML(markdownText) {
      let htmlText = markdownText.replace(
        /\*\*(.*?)\*\*/g,
        "<strong>$1</strong>"
      );
      return htmlText;
    },
    handleCopy() {
      //将content复制到剪贴板
      this.$copyText(this.content).then(() => {
        this.$message.success("复制成功");
      });
    },
    //随机id生成
    randomId() {
      return Math.random()
        .toString(36)
        .substr(2, 15);
    },
    typeWriter() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      const speed = 5000 / (this.waitText.length - this.waitIndex) > 40 ? 40 : 5000 / (this.waitText.length - this.waitIndex);
      this.timer = setInterval(() => {
        if (this.waitIndex < this.waitText.length) {
          if ( [1,2,3,4,5,6,7,8,9,10,11,12].includes(this.waitText[this.waitIndex]) ) {
            this.content += `${this.waitText[this.waitIndex]}`
            console.log(this.content);
          } else {
            this.content += this.waitText[this.waitIndex];
          }
          this.waitIndex++
        } else {
          clearInterval(this.timer);
        }
      }, speed);
    },
    readLines(stream) {
      let streamData = this.lastStr + stream;
      this.lastStr = ''
      streamData = streamData.replace(/^data: /gm, ""); // 移除每行开头的 "data:"
        streamData = streamData.trim().split("\n");
        streamData.forEach((item) => {
          if (item.indexOf('}') > -1) {
            const i = item.indexOf('{')
            const str = item.substring(i, item.length)
            const data = JSON.parse(str)
            if (data.answer) {
              this.waitText += data.answer
              this.typeWriter()
            }
          } else {
            this.lastStr = item
          }
        });
    },
    async handleConfirm() {
      const data = this.chatData[this.type];
      //验证参数 不满足则不发送请求
      if (!this.query) {
        this.$message.error("请填写问题");
        return;
      }
      let check = true;
      for (let i = 0; i < data.params.length; i++) {
        const element = data.params[i];
        console.log(this.form);
        if (element.required && !this.form[element.value]) {
          this.$message.error(`${element.name}不能为空`);
          check = false;
          break;
        }
      }
      if (!check) return;
      this.showAiDetail = true;
      this.content = "";
      this.loading = true;

      try {

        // let response = await fetch(data.url, {
        //   method: data.method,
        //   headers: {
        //     Authorization: `Bearer ${data.aiKey}`,
        //     "Content-Type": "application/json",
        //   },
        //   timeout: 0,
        //   body: JSON.stringify({
        //     id: data.id,
        //     response_mode: "streaming",
        //     inputs: {
        //       ...this.form,
        //     },
        //     user: this.userInfo.id,
        //     query: this.query,
        //   }),
        // });

        let response = await fetch( directorTestApi.domain + data.url2 + '?id=' + data.id, {
            method: data.method,
            headers: {
              Authorization: `Bearer ${this.headers}`,
              "Content-Type": "application/json",
            },
            timeout: 0,
            body: JSON.stringify({
              id: data.id,
              response_mode: "streaming",
              inputs: {
                ...this.form,
              },
              user: this.userInfo.id,
              query: this.query,
              teacher_id: this.userInfo.id
            }),
          });
        
        // if (!response.result) {
        //   this.loading = false;
        //   setTimeout(() => {
        //     this.showAiDetail = false;
        //   }, 20)
        //   return
        // }

        const reader = response.body.getReader();
        //如何将流数据数组化，流数据以data:开头

        let streamData = "";

        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            this.loading = false;
            this.getKeys()
            break;
          };
          const lines = new TextDecoder("utf-8").decode(value);
          console.log(lines,'readline');
          this.readLines(lines);
        }

      } catch (error) {
        console.log(error);
        this.$message.error("请求失败,请尝试修改后重新生成");
        this.loading = false;
        setTimeout(() => {
          this.showAiDetail = false;
        });
      }
    },
    handleUse(type) {
    this.waitIndex = 0
    this.lastStr = ''
    this.waitText = ''
      this.type = type;
      if (this.chatData[this.type].query) {
        this.query = "";
      } else {
        this.query = "帮我生成文案";
      }

      this.form = {};
      this.showDetail = true;
    },
    close() {
      this.show = false;
      this.$emit("input", this.show);
    },
  },
};
</script>

<style lang="scss" >
.content p {
  margin-bottom: 0;
}
</style>

<style lang="scss" scoped>
.ai-banner {
  width: 100%;
}

.foot2 {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  height: 90px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-left: 40px;
  .btn {
    background: #67b0dc;
    color: #fff;
    text-align: center;
    width: 200px;
    border-radius: 100px;
    height: 40px;
    cursor: pointer;
    line-height: 40px;
    margin-right: 40px;
    &:hover {
      background: #4ea2d6;
    }
  }
}

.foot {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  height: 90px;
  display: flex;
  flex-direction: row;
  align-items: center;
  .btn {
    background: #67b0dc;
    color: #fff;
    text-align: center;
    width: 200px;
    border-radius: 100px;
    height: 40px;
    cursor: pointer;
    line-height: 40px;
    margin: 0 auto;
    &:hover {
      background: #4ea2d6;
    }
  }
}

.tip2 {
  color: #999;
  font-size: 12px;
  margin-bottom: 10px;
}

.bg {
  width: 100%;
  height: 170px;
  //渐变背景
  background: linear-gradient(to bottom, #63a9d4, #fff);
  padding: 20px;
  display: flex;
  flex-direction: row;
  img {
    width: 42px;
    height: 42px;
    border-radius: 38px;
    margin-right: 10px;
  }
  .name {
    color: #fff;
    font-size: 16px;
  }
  .time {
    font-size: 12px;
    color: #fff;
    opacity: 0.9;
    margin-top: 1px;
  }
}

.ai-form {
  padding: 0 20px;
  margin-top: 10px;
  box-sizing: border-box;
  .content {
    width: 100%;
    padding: 15px;
    border-radius: 6px;
    background: #fff;
    overflow: hidden;
    min-height: 200px;
    color: #333;
    font-size: 16px;
    white-space: pre-wrap;
  }
  .item {
    margin-bottom: 25px;
    width: 100%;
    .title {
      font-size: 16px;
      color: #67b0dc;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .ai-list {
      width: 100%;
    }
    .cell {
      width: 100%;
      border-radius: 10px;
      background: #fff;
      overflow: hidden;
      box-shadow: 0 0 10px rgba(45, 131, 189, 0.16);
      display: flex;
      margin-bottom: 20px;
      flex-direction: row;
      padding: 10px;
      align-items: center;
      .icon {
        width: 48px;
        height: 48px;
        margin-right: 8px;
      }

      .msg {
        flex: 1;
        .name {
          color: #67b0dc;
          font-size: 15px;
        }
        .tip {
          color: #111;
          font-size: 14px;
        }
      }
      .btn {
        width: 60px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        cursor: pointer;
        color: #fff;
        background: #67b0dc;
        border-radius: 100px;
      }
    }
  }
}
.form-wrapper {
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  .form-item {
    width: 100%;
    margin-bottom: 15px;
    .title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      margin-bottom: 10px;
    }
  }
}
</style>
